// AboutContext — lets the Settings screen (rendered deep inside SidebarNav)
// open the About modal owned by App.tsx without prop drilling.

import { createContext, useContext } from 'react';

export type OpenAboutFn = () => void;

export const AboutContext = createContext<OpenAboutFn | null>(null);

export function useAboutOpener(): OpenAboutFn | null {
  return useContext(AboutContext);
}
